// extracted by mini-css-extract-plugin
export default {"container":"UsersAdmin_container__4UaIr","buttonHolder":"UsersAdmin_buttonHolder__T2uwX","socialHolder":"UsersAdmin_socialHolder__x-PuL"};